import { Checkbox } from '@/shared/ui'

/** What a list's "Show deactivated" (or disabled, or archived) option needs. */
export interface InactiveOptionProps {
  /** The option's label, in the list's own word, such as "Show deactivated". */
  readonly label: string
  readonly checked: boolean
  readonly onChange: (checked: boolean) => void
}

/**
 * A search's option to list switched-off records too, as one of the mockups' filter checkboxes (the
 * course catalog's Filters panel). Self-contained, so whichever filter area a screen has can hold it.
 */
export function InactiveOption(props: InactiveOptionProps) {
  return <Checkbox checked={props.checked} onChange={props.onChange} label={props.label} />
}
